
<template>
  <div class="logo-uploader">
    <div v-if="value" class="logo-uploader-image-wrapper">
      <img @click="openImagePicker" :src="value" class="image-prev">
      <ProTagWithUpgradeTooltip v-if="compact" @upgrade="showUpgradeModal" :upgrade-intent="upgradeIntent" class="logo-uploader-pro-tag" />
    </div>
    <div @click="openImagePicker" v-else class="image-prev empty">
      <span class="label">
        <slot name="default">{{ label }}</slot>
      </span>
    </div>
    <div v-if="!compact">
      <div @click="openImagePicker" class="button is-light-bg">Upload</div>
      <div @click="remove()" class="button is-light-bg"><i class="fas fa-times" /></div>
      <UpgradeNotification v-if="!isProUser && value">
        <UpgradeNotificationContent @upgrade="showUpgradeModal" :intent="upgradeIntent" />
      </UpgradeNotification>
    </div>
  </div>
</template>

<script>
import ImagePicker from '~/components/modals/ImagePicker'
import UpgradeModal from '~/components/modals/UpgradeModal'
import UpgradeNotificationContent from '~/components/upgrade/UpgradeNotificationContent'
import ProTagWithUpgradeTooltip from '~/components/upgrade/ProTagWithUpgradeTooltip'
import UpgradeNotification from '~/components/upgrade/UpgradeNotification'

export default {
  name: 'LogoUploader',
  components: { UpgradeNotification, ProTagWithUpgradeTooltip, UpgradeNotificationContent },
  props: {
    value: {
      type: [String, Boolean],
      required: true
    },
    label: {
      type: String,
      default: 'Add your logo ✨'
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      upgradeIntent: 'see your logo in live events',
      openModals: []
    }
  },
  computed: {
    isProUser () {
      return this.$store.getters.isProUser
    }
  },
  mounted () {
    document.addEventListener('keydown', this.handleEscape)
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.handleEscape)
  },
  methods: {
    showUpgradeModal () {
      const modal = this.$buefy.modal.open({
        parent: this,
        fullScreen: false,
        component: UpgradeModal,
        props: {
          title: 'Upgrade to use a custom logo',
          subtitle: 'A Pro account lets you remove the Slides With Friends logo and display your own in live events.',
          from_location: 'logo-uploader',
          button_text: 'Upgrade to use a custom logo'
        },
        canCancel: ['button', 'x', 'outside'],
        customClass: 'upgrade-modal swf-modal',
        width: 400,
        trapFocus: true
      })
      this.openModals.push(modal)
    },
    openImagePicker () {
      const modal = this.$buefy.modal.open({
        parent: this,
        component: ImagePicker,
        trapFocus: true,
        width: 600,
        canCancel: ['button', 'x', 'outside'],
        events: {
          updateImg: (data) => {
            this.$emit('input', data.downloadUrl)
          },
          upgrade: () => {
            this.showUpgradeModal()
          }
        },
        props: {
          value: this.value,
          notifyFreeUsers: true
        }
      })
      this.openModals.push(modal)
    },
    remove () {
      this.$emit('input', '')
    },
    handleEscape (evt) {
      if (evt.keyCode !== 27) {
        return
      }

      const modal = this.openModals.pop()
      if (modal) {
        modal.close()
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '~~/assets/css/components';

.logo-uploader {
  .logo-uploader-image-wrapper {
    position: relative;
    width: auto;
    display: inline-block;
  }
  .logo-uploader-pro-tag {
    top: -3px;
    right: 4px;
  }
  .image-prev {
    cursor: pointer;
    height: 115px;
    object-fit: contain;
    margin-bottom: -7px;
    border-radius: 6px;

    &.empty {
      background-color: #FBFBFB;
      border: 2px dashed #E0E0E0;
      border-radius: 6px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 1.5em;

      &:not(:last-child) {
        margin-bottom:10px;
      }

      span.label {
        opacity: .8;
      }
    }
  }

  &.is-aligned-left {
    .image-prev {
      width: auto;
    }
  }
}
</style>
